import { useTranslation } from 'react-i18next';
import SessionIsStartingWrapper from '../../components/SessionIsStartingWrapper/SessionIsStartingWrapper';
import './SessionIsStartingLooker.scoped.scss';
import { IonRow, useIonModal } from '@ionic/react';
import { resetAll, sessionIdSelector, subjectSelector } from '../../store/slices';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../store/store';
import { useEffect } from 'react';
import { replace } from 'redux-first-history';
import WarningModal from '../../components/WarningModal/WarningModal';
import { OverlayEventDetail } from '@ionic/react/dist/types/components/react-component-lib/interfaces';
import { SessionIdRequest } from '../../models';
import { useLookerCancelMutation } from '../../store/api';

const SessionIsStartingLooker: React.FC = () => {
  const { t } = useTranslation();
  const subject = useSelector(subjectSelector);
  const dispatch = useAppDispatch();
  const [lookerCancel] = useLookerCancelMutation();
  const sessionId = useSelector(sessionIdSelector);

  useEffect(() => {
    if (subject?.ready) {
      dispatch(replace('/get-ready-looker'));
    }
  }, [subject?.ready, dispatch]);

  const [present, dismiss] = useIonModal(WarningModal, {
    onDismiss: (data: string, role: string) => dismiss(data, role),
  });

  const openModal = (back: Function) => {
    present({
      onWillDismiss: async (ev: CustomEvent<OverlayEventDetail>) => {
        if (ev.detail.role === 'accept') {
          const response = await lookerCancel({
            sessionId: sessionId,
          } as SessionIdRequest).unwrap();
          if (response) {
            dispatch(resetAll());
            back();
          }
        }
      },
    });
  };

  return (
    <SessionIsStartingWrapper openModal={openModal}>
      <IonRow className="subtitle ion-justify-content-center ion-no-padding ion-no-margin waiting-subject">
        {t('Waiting for Subject to start')}
      </IonRow>
    </SessionIsStartingWrapper>
  );
};

export default SessionIsStartingLooker;
